<template>
    <div class="v-raster-geodata-quick-settings">
        <SmartSelect v-model="requestSettings.colorScheme" :options="colorSchemeOptions"
            :label-fn="(v: string) => v === 'red-yellow-blue' ? 'Farbe' : 'Grau'"
            class="v-raster-geodata-quick-settings__select" title="Farbschema" />
        <SmartSelect v-if="hasTimestamps" v-model="requestSettings.timestamp" :options="timestampOptions"
            :label-fn="(v: string) => v" class="v-raster-geodata-quick-settings__timestamp-select" title="Zeitpunkt" />
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SmartSelect } from "gertrud";
import { RasterGeodataMapModule } from "@/mapModules/rasterGeodata/RasterGeodataMapModule";

const props = defineProps<{
    mapModule: RasterGeodataMapModule
}>();

const requestSettings = props.mapModule.reactiveData.requestSettings;

const colorSchemeOptions = ["red-yellow-blue", "greyscale"];

const hasTimestamps = computed(() => {
    return props.mapModule.reactiveData.availableTimestamps.length > 0;
});

const timestampOptions = computed(() => {
    return props.mapModule.reactiveData.availableTimestamps;
});
</script>

<style scoped lang="scss">
.v-raster-geodata-quick-settings {
    display: flex;
    align-items: center;
    gap: 6px;
}

.v-raster-geodata-quick-settings__select {
    min-width: 70px;
    max-width: 90px;
}

.v-raster-geodata-quick-settings__timestamp-select {
    min-width: 70px;
    max-width: 100px;
}
</style>
